import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    IConfigChangeHistoryState,
    PaginatedConfigChangeHistory,
} from '../../types/configChangeHistory'
import { fetchConfigChangeHistory } from '../async-thunks/configChangeHistory/fetchConfigChangeHistory'

const initialState: IConfigChangeHistoryState = {
    isLoading: false,
    error: '',

    // filters
    from: undefined,
    to: undefined,
    login: undefined,
    status: undefined,
    page: 1,
    limit: 20,

    // @ts-expect-error
    productConfigChangeHistory: {},
}

const configChangeHistorySlice = createSlice({
    name: 'actionsSlice',
    initialState,
    reducers: {
        setFrom: (state, action: PayloadAction<string | undefined>) => {
            state.from = action.payload
        },
        setTo: (state, action: PayloadAction<string | undefined>) => {
            state.to = action.payload
        },
        setLogin: (state, action: PayloadAction<string | undefined>) => {
            state.login = action.payload
        },
        setStatus: (state, action: PayloadAction<string | undefined>) => {
            state.status = action.payload
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload
        },
        setLimit: (state, action: PayloadAction<number>) => {
            state.limit = action.payload
        },
        setFilters: (state, action: PayloadAction<any>) => {
            state.from = action.payload?.from
            state.to = action.payload?.to
            state.login = action.payload?.login
            state.status = action.payload?.status
            if (typeof action.payload?.page === 'number') {
                state.page = action.payload.page
            }
        },
        resetAll: (state) => {
            state = initialState
            return state
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchConfigChangeHistory.pending, (state) => {
                state.isLoading = true
                state.error = ''
            })
            .addCase(
                fetchConfigChangeHistory.fulfilled,
                (
                    state,
                    action: PayloadAction<{
                        productId: string
                        data: PaginatedConfigChangeHistory
                    }>
                ) => {
                    const { data } = action.payload
                    state.isLoading = false
                    state.productConfigChangeHistory = data
                }
            )
            .addCase(fetchConfigChangeHistory.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload || ''
            })
    },
})

export const { actions: configChangeHistoryActions } = configChangeHistorySlice
export const { reducer: configChangeHistoryReducer } = configChangeHistorySlice
